import { Controller } from "@hotwired/stimulus"

// Copy-to-clipboard for the MCP setup page. Buttons carry the text to copy in a
// `data-copy` attribute and `data-action="mcp-setup#copy"`.
export default class extends Controller {
  copy(event) {
    const button = event.currentTarget
    const text = button.dataset.copy
    if (!text) return

    navigator.clipboard.writeText(text).then(() => {
      const original = button.textContent
      button.textContent = "Copied!"
      setTimeout(() => { button.textContent = original }, 1500)
    })
  }
}
